// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"77ab85ea0cfac4195bea","655":"a523196133446c10d30f"}[chunkId] + ".js";
};